var $dc6e3b2813600d69$exports = {};
$dc6e3b2813600d69$exports = {
    "close": `Bez\xe1r\xe1s`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`,
            other: ()=>`${formatter.number(args.count)} \xe9rtes\xedt\xe9s`
        })}.`
};


export {$dc6e3b2813600d69$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
